import { render } from "./VNavigation.vue?vue&type=template&id=fbff6960&scoped=true"
import script from "./VNavigation.vue?vue&type=script&lang=js"
export * from "./VNavigation.vue?vue&type=script&lang=js"

import "./VNavigation.vue?vue&type=style&index=0&id=fbff6960&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbff6960"]])

export default __exports__